import { createContext, useContext } from 'react';
export var DuperbrowseViewContext = createContext(undefined);
DuperbrowseViewContext.displayName = 'DuperbrowseViewContext';
export function useDuperbrowseViewType() {
    var viewType = useContext(DuperbrowseViewContext);
    return {
        viewType: viewType,
        isInDuperbrowse: !!viewType,
    };
}
//# sourceMappingURL=DuperbrowseViewContext.js.map